const generateItemId = (index, timestamp) => `${index}_${timestamp}`;

export default generateItemId;
